import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./AuthProvider";
import AppShell from "./AppShell";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  </React.StrictMode>
);
